import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import * as React from "react";
import { LocalizedText } from "bernie-l10n";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelNameRatingAndAddress } from "./HotelNameRatingAndAddress";
import { NearestLocationContent } from "./NearestLocation/NearestLocationContent";
import { useLocalization } from "@shared-ui/localization-context";
import { validPrice } from "components/flexComponents/Hotels/utils/isValidPrice";
import { BeachProximity } from "./BeachProximity/BeachProximity";
import { Description } from "./Description";
import PriceLockup from "../views/HotelsViews/components/shared/PriceLockup";
import { HotelPriceLockupWithDates } from "../utils/A11y/HotelPriceLockupWithDates";

/**
 * CardContent which contains the overall ratings, pricing, value proposition
 * and guest amount (hard coded)
 */
export const CardContentReviewsPriceProposition = ({
  hotel,
  locale,
  locationName,
  context,
  isMobile,
  isViewCarousel,
  showCheckPrices,
  showGetPriceIfNoPrice,
  showDistance,
  showAddress,
  shouldUseImperialDistanceUnits,
  addressDistanceView,
}: {
  hotel: Hotel;
  locale: string;
  locationName: string;
  context: ExtendedContextStore;
  isMobile?: boolean;
  isViewCarousel?: boolean;
  showCheckPrices?: boolean;
  showGetPriceIfNoPrice?: boolean;
  showDistance?: boolean;
  showAddress?: boolean;
  shouldUseImperialDistanceUnits?: boolean;
  addressDistanceView?: string;
}) => {
  const { formatText, formatDateString } = useLocalization();
  const { isValidPrice, showGetRates } = validPrice(hotel, isMobile, showCheckPrices, showGetPriceIfNoPrice);

  return (
    <>
      {isViewCarousel ? (
        <>
          <div className="uitk-grid">
            <div className="uitk-cell fill">
              <div className="truncate uitk-type-heading-500 uitk-type-bold">{hotel.hotelName}</div>
            </div>
          </div>

          <div className="uitk-grid all-x-gutter-two">
            <div className="uitk-cell fill">
              <HotelNameRatingAndAddress
                hotel={hotel}
                locale={locale}
                context={context}
                isViewCarousel={isViewCarousel}
                showAddress={showAddress}
                showDistance={showDistance}
                locationName={locationName}
                shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
                addressDistanceView={addressDistanceView}
              />
            </div>
            {isValidPrice && (
              <PriceLockup
                hotel={hotel}
                className="uitk-cell shrink"
                priceA11y={new HotelPriceLockupWithDates(hotel, formatText, formatDateString)}
              />
            )}
            {showGetRates && (
              <div className="uitk-cell shrink uitk-type-right">
                <div className="uitk-type-600 hotelPricing">
                  <b>
                    <LocalizedText message="hotels.price.getRates" />
                  </b>
                </div>
              </div>
            )}
            <Description hotel={hotel} />
            <NearestLocationContent
              context={context}
              model={hotel.directDistance}
              shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
            />
          </div>
        </>
      ) : (
        <div className="uitk-grid all-x-gutter-two">
          <div className="uitk-cell fill">
            <HotelNameRatingAndAddress
              hotel={hotel}
              locale={locale}
              context={context}
              isViewCarousel={isViewCarousel}
              showAddress={showAddress}
              showDistance={showDistance}
              locationName={locationName}
              shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
              addressDistanceView={addressDistanceView}
            />
          </div>
          {isValidPrice && (
            <PriceLockup
              hotel={hotel}
              className="uitk-cell shrink"
              priceA11y={new HotelPriceLockupWithDates(hotel, formatText, formatDateString)}
            />
          )}
          {showGetRates && (
            <div className="uitk-cell shrink uitk-type-right">
              <div className="uitk-type-600 hotelPricing">
                <b>
                  <LocalizedText message="hotels.price.getRates" />
                </b>
              </div>
            </div>
          )}
          <Description hotel={hotel} />
          <NearestLocationContent
            context={context}
            model={hotel.directDistance}
            shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
          />
          <BeachProximity {...hotel.nearbyBeach} />
        </div>
      )}
    </>
  );
};
